/**
 * Cache Strategy Factory
 * Creates appropriate strategy instance based on key
 */

import { BaseCacheStrategy } from './baseCacheStrategy'
import { HomepageCacheStrategy } from './homepageCacheStrategy'
import { MenuCacheStrategy } from './menuCacheStrategy'

export class CacheStrategyFactory {
  /**
   * Create cache strategy instance
   * @param {string} key - Cache key
   * @param {string} type - Strategy type ('homepage', 'menu', 'base')
   * @returns {BaseCacheStrategy} Strategy instance
   */
  static create(key, type = 'base') {
    switch (type) {
      case 'homepage':
        return new HomepageCacheStrategy(key)
      case 'menu':
        return new MenuCacheStrategy(key)
      default:
        return new BaseCacheStrategy(key)
    }
  }

  /**
   * Auto-detect strategy type based on key
   * @param {string} key - Cache key
   * @returns {BaseCacheStrategy} Strategy instance
   */
  static autoCreate(key) {
    const homepageKeys = [
      'bonusGames',
      'newGames',
      'newUserGames',
      'hotPGGames',
      'popularGames'
    ]
    const menuKeys = ['new-games', 'hot-games', 'popular-games']

    if (homepageKeys.includes(key)) {
      return this.create(key, 'homepage')
    }
    if (menuKeys.includes(key)) {
      return this.create(key, 'menu')
    }

    return this.create(key, 'base')
  }
}

export default CacheStrategyFactory
